import { render, staticRenderFns } from "./StudentSignUpCourseAddEdit.vue?vue&type=template&id=1ddc2ead"
import script from "./StudentSignUpCourseAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentSignUpCourseAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports